export const OOHOMEPAGE_CONST = {
    pageNameLoggedIn: "Home-Logged-In",
    pageType: "Home",
    pageName: "Home",
    clickTypeOpen: "Open:",
    clickNameTarget: "Message",
    clickTrackSection: "Content",
    linkType: "CTA"
}